import { Tooltip, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { useState } from 'react';
import { Link as RRLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    logo: {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.text.primary,
      textDecoration: 'none'
    },
    backspaceName: {
      fontFamily: 'Comfortaa',
      fontWeight: 700,
      fontSize: '1.9rem',
      letterSpacing: -2,
      [theme.breakpoints.down('xs')]: {
        fontSize: '1.6rem',
        letterSpacing: -1.5
      }
    },
    systemName: {
      marginTop: theme.spacing(0.25),
      marginLeft: theme.spacing(0.75),
      padding: theme.spacing(0.25, 0.75),
      background: theme.palette.gradient?.main,
      color: theme.palette.background.paper,
      borderRadius: '8px',
      fontFamily: 'Comfortaa',
      fontWeight: 700,
      [theme.breakpoints.down('xs')]: {
        marginTop: 0.1
      }
    }
  })
);

export default function BackspaceLogo(systemName: string) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [backspaceName, setBackspaceName] = useState<boolean>(false);

  return (
    <Tooltip title={t('backspaceLogo.goToHome') as string} placement="bottom-start">
      <RRLink
        className={classes.logo}
        to="/"
        onMouseEnter={() => setBackspaceName(true)}
        onMouseLeave={() => setBackspaceName(false)}
        onKeyUp={() => setBackspaceName(true)}
        onKeyDown={() => setBackspaceName(false)}
        aria-label={t('common.appName') as string}
      >
        <Typography className={classes.backspaceName}>
          {backspaceName ? 'backspace' : 'space'}
        </Typography>
        {!backspaceName && (
          <Typography className={classes.systemName}>{systemName}</Typography>
        )}
      </RRLink>
    </Tooltip>
  );
}
